export default {
      id: "tpms_attention-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.svg#tpms_attention",
      toString: function () {
        return this.url;
      }
    }